// import React, { useState, useEffect, useContext } from "react";
// import {
//   Label,
//   Form,
//   FormGroup,
//   Row,
//   Col,
//   Input,
//   InputGroup,
// } from "reactstrap";
// import DatePicker from "react-datepicker";
// import { useController, useForm } from "react-hook-form";
// import { showAlert } from "../../Services/Shared.service";
// import {
//   createPackage,
//   createPackageRate,
//   getPackageRate,
// } from "../../Services/Packages.service";
// import moment from "moment";
// import CustomSelect from "../../CommonElements/CustomSelect";
// import CustomizerContext from "../../_helper/Customizer";
// import { getPackagesList } from "../../Services/Packages.service";
// import SharedDataContext from "../../_helper/SharedData";
// import PackageRatesTable from "./PackageRatesTable";
// import { Button } from "@mui/material";
// import AddBoxIcon from "@mui/icons-material/AddBox";

// function PackagesRatesForms({ createdPackage, setTitle }) {
//   const {
//     register,
//     control,
//     handleSubmit,
//     formState: { errors },
//     setValue,
//     getValues,
//     reset,
//   } = useForm({
//     defaultValues: {
//       package: "",
//       minPkgDistance: "",
//       pkgDistance: "",
//       pkgTimeInMin: "",
//       pkgCharge: "",
//       addnlPerKmCharge: "",
//       addnlTimeCharge: "",
//       addnlTimeChargeBlockInMin: "",
//       isTaxInclusive: false,
//       timeFrom: "",
//       timeTo: "",
//       isTimeBased: false,
//       maxPkgDistance: "",
//       packageValue: "",
//       isNightfareTimeSlot: false,
//       packageRideType: "",
//     },
//   });
//   useEffect(() => {
//     console.log("created PackageName", createdPackage?.name);
//     setDefaultOpt(createdPackage?.name);
//     setValue("package", JSON.stringify(createdPackage ? createdPackage : ""));
//     setPackageName(createdPackage.name);
//   }, [createdPackage]);

//   console.log("createdPackage.name", createdPackage.name);

//   useEffect(() => {
//     console.log("created package", createdPackage);
//     if (createdPackage?.id) {
//       packageField.onChange(createdPackage);
//     }
//   }, [createdPackage]);

//   const values = getValues();
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const { mix_background_layout } = useContext(CustomizerContext);
//   const [packageRateObj, setPackageRateObj] = useState({});
//   const [packagesData, setPackagesData] = useState([]);
//   const [defaultOpt, setDefaultOpt] = useState({ "": "" });
//   const [packagePresent, setPackagePresent] = useState(false);
//   const { setTabValue } = useContext(SharedDataContext);
//   const [form, setForm] = useState(false);
//   const [search, setSearch] = useState(true);
//   const [exist, setExist] = useState(false);
//   const [packageName, setPackageName] = useState("");
//   console.log("created package is ", createdPackage);
//   const isTaxInclusiveField = useController({
//     name: "isTaxInclusive",
//     control,
//   }).field;

//   const isTimeBasedField = useController({
//     name: "isTimeBased",
//     control,
//   }).field;

//   const isNightfareTimeSlotField = useController({
//     name: "isNightfareTimeSlot",
//     control,
//   }).field;

//   // const packageField = useController({
//   //     name: "package",
//   //     control,
//   //     rules: {
//   //         required: {
//   //             value: true,
//   //             message: "Package is Required",
//   //         },
//   //     },
//   // }).field;

//   // const handlePackageField = (data) => {
//   //     packageField.onChange(data.value)
//   // }

//   const packageRideTypeField = useController({
//     name: "packageRideType",
//     control,
//     rules: {
//       required: {
//         value: true,
//         message: "Package is Required",
//       },
//     },
//   }).field;

//   const handlePackageRideTypeSelectChange = (data) => {
//     packageRideTypeField.onChange(data.value);
//   };

//   const addnlTimeChargeBlockInMinField = useController({
//     name: "addnlTimeChargeBlockInMin",
//     control,
//     rules: {
//       required: {
//         value: true,
//         message: "Extra Time Block (in hours) is Required",
//       },
//     },
//   }).field;

//   const handleAddnlTimeChargeBlockInMin = (data) => {
//     addnlTimeChargeBlockInMinField.onChange(data);
//   };

//   const pkgTimeInMinField = useController({
//     name: "pkgTimeInMin",
//     control,
//     rules: {
//       required: {
//         value: true,
//         message: "Package Hours is Required",
//       },
//     },
//   }).field;

//   const handlePkgTimeInMinDate = (data) => {
//     pkgTimeInMinField.onChange(data);
//   };

//   const timeFromField = useController({
//     name: "timeFrom",
//     control,
//     rules: {
//       required: {
//         value: isTimeBasedField.value ? true : false,
//         message: "Applicable From is Required",
//       },
//     },
//   }).field;

//   const handleTimeFrom = (data) => {
//     timeFromField.onChange(data);
//   };

//   const timeToField = useController({
//     name: "timeTo",
//     control,
//     rules: {
//       required: {
//         value: isTimeBasedField.value ? true : false,
//         message: "Applicable To is Required",
//       },
//     },
//   }).field;

//   const handleTimeTo = (data) => {
//     timeToField.onChange(data);
//   };

//   const rideTypeDatas = [
//     { label: "All", value: "All" },
//     { label: "AirportToCity", value: "AirportToCity" },
//     { label: "CityToAirport", value: "CityToAirport" },
//     { label: "CityToCity", value: "CityToCity" },
//   ];

//   useEffect(() => {
//     const fetchTableData = () => {
//       const serviceCityId = null;
//       let obj = {
//         isPagination: false,
//         serviceCityId: serviceCityId,
//         page: 0,
//         size: 30,
//       };
//       getPackagesList(obj).then((result) => {
//         let packageOptions = result.data.list.map((d) => {
//           return {
//             label: d.name,
//             value: d,
//           };
//         });
//         setPackagesData(packageOptions);
//       });
//     };
//     fetchTableData();
//   }, []);

//   // useEffect(() => {
//   //     console.log("created package",createdPackage);
//   //     if (createdPackage?.id) {
//   //         packageField.onChange(createdPackage.name)
//   //     }
//   // }, [packageField])

//   const packageField = useController({
//     name: "package",
//     control,
//     rules: {
//       required: {
//         value: true,
//         message: "Package is Required",
//       },
//     },
//   }).field;

//   useEffect(() => {
//     if (createdPackage.id) {
//       packageField.onChange({
//         id: createdPackage.id,
//         name: createdPackage.name,
//       });
//       // console.log("createdd package inside useEffect",createdPackage.name)
//     }
//   }, [createdPackage]);
//   const handleTime_To = (time, constraint) => {
//     let timeto =
//       constraint == "S"
//         ? Number(moment.duration(moment(time).format("HH:mm:ss")).asSeconds())
//         : Number(moment.duration(moment(time).format("HH:mm:ss")).asMinutes());
//     if (timeto === 0 && constraint == "S") {
//       return 86400;
//     } else if (timeto === 0 && constraint == "M") {
//       return 1440;
//     }
//     return timeto;
//   };
//   const onFormSubmit = (formValues) => {
//     setIsSubmitting(true);
//     console.log("form values", formValues);
//     const body = {
//       packagesId: Number(formValues.package.id),
//       minPkgDistance: formValues.minPkgDistance
//         ? Number(formValues.minPkgDistance)
//         : 0,
//       pkgDistance: formValues.pkgDistance ? Number(formValues.pkgDistance) : 0,
//       pkgTimeInMin: formValues.pkgTimeInMin
//         ? handleTime_To(formValues.pkgTimeInMin, "M")
//         : 0,
//       pkgCharge: formValues.pkgCharge ? Number(formValues.pkgCharge) : 0,
//       addnlPerKmCharge: formValues.addnlPerKmCharge
//         ? Number(formValues.addnlPerKmCharge)
//         : 0,
//       addnlTimeCharge: formValues.addnlTimeCharge
//         ? Number(formValues.addnlTimeCharge)
//         : 0,
//       addnlTimeChargeBlockInMin: formValues.addnlTimeChargeBlockInMin
//         ? Number(
//             moment
//               .duration(
//                 moment(formValues.addnlTimeChargeBlockInMin).format("HH:mm:ss")
//               )
//               .asMinutes()
//           )
//         : 0,
//       isTaxInclusive: formValues.isTaxInclusive ? true : false,
//       timeFrom: formValues.timeFrom
//         ? Number(
//             moment
//               .duration(moment(formValues.timeFrom).format("HH:mm:ss"))
//               .asSeconds()
//           )
//         : 0,
//       timeTo: formValues.timeTo ? handleTime_To(formValues.timeTo, "S") : 86400,
//       // timeFrom: 0,
//       // timeTo: 0,
//       isTimeBased: formValues.isTimeBased ? true : false,
//       maxPkgDistance: formValues.maxPkgDistance
//         ? Number(formValues.maxPkgDistance)
//         : 0,
//       packageValue: formValues.packageValue
//         ? Number(formValues.packageValue)
//         : 0,
//       isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
//       packageRideType: formValues.packageRideType,
//     };
//     createPackageRate(body)
//       .then((result) => {
//         reset({
//           package: "",
//           minPkgDistance: "",
//           pkgDistance: "",
//           pkgTimeInMin: "",
//           pkgCharge: "",
//           addnlPerKmCharge: "",
//           addnlTimeCharge: "",
//           addnlTimeChargeBlockInMin: "",
//           isTaxInclusive: false,
//           timeFrom: "",
//           timeTo: "",
//           isTimeBased: false,
//           maxPkgDistance: "",
//           packageValue: "",
//           isNightfareTimeSlot: false,
//           packageRideType: "",
//         });
//         showAlert("success", "Package Rate Created Successfully");
//         setIsSubmitting(false);
//         setTabValue(0);
//       })
//       .catch((err) => {
//         showAlert(
//           "error",
//           err.response?.data?.message
//             ? err.response.data.message
//             : "Something went wrong"
//         );
//         setIsSubmitting(false);
//       });
//   };

//   // useEffect(()=>{
//   //     if(selectedPackage.id){
//   //         packageField.onChange({ id: selectedPackage.id, name: selectedPackage.name })
//   //     }
//   // },[selectedPackage])

//   return (
//     <div>
//       {/* {search ? (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <div
//             style={{
//               width: "400px",
//               display: "flex",
//               flexDirection: "column",
//               gap: "20px",
//             }}
//           >
//             <Button
//               sx={{
//                 width: "100%",
//                 fontSize: "1rem",
//                 color: "#41CC7D",
//                 borderColor: "#41CC7D",
//                 "&:hover": {
//                   borderColor: "#41CC7D",
//                 },
//               }}
//               variant="outlined"
//               startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
//               onClick={() => {
//                 setTitle("Create Package Rate");
//                 setSearch(false);
//                 setForm(true);
//               }}
//             >
//               New Package Rates
//             </Button>
//             <Button
//               sx={{
//                 width: "100%",
//                 fontSize: "1rem",
//                 color: "#41CC7D",
//                 borderColor: "#41CC7D",
//                 "&:hover": {
//                   borderColor: "#41CC7D",
//                 },
//               }}
//               variant="outlined"
//               startIcon={<AddBoxIcon sx={{ color: "#41CC7D" }} />}
//               onClick={() => {
//                 setTitle("Edit Package Rate");
//                 setSearch(false);
//                 setForm(false);
//                 setExist(true);
//               }}
//             >
//               Existing Package Rates
//             </Button>
//           </div>
//         </div>
//       ) : null} */}
//       {/* {form ? ( */}
//       <Form onSubmit={handleSubmit(onFormSubmit)}>
//         <Row>
//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Package</Label>
//             <Col lg="12">
//               <div className="city-select">
//                 {createdPackage ? (
//                   <input
//                     className="form-control"
//                     type="text"
//                     disabled={true}
//                     // value={`${createdPackage.name}`}
//                     value={packageField.value.name}
//                     // {...register("package",{
//                     //     required: {
//                     //         value: true,
//                     //         message: "Package is required",
//                     //     },
//                     // })}
//                   />
//                 ) : (
//                   <CustomSelect
//                     className="service-select"
//                     classNamePrefix="select"
//                     isClearable={false}
//                     isSearchable={false}
//                     //  isDisabled={editId ? true : false}
//                     value={
//                       packageField?.value?.id
//                         ? packagesData.find((element) => {
//                             return (
//                               element?.value?.id === packageField?.value?.id
//                             );
//                           })
//                         : ""
//                     }
//                     //   // defaultValue={cityData.find((element) => {
//                     //   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
//                     //   //   return element?.value?.id === cityField?.value?.id;
//                     //   // })}

//                     //  onChange={}
//                     placeholder="Select Package"
//                     options={packagesData}
//                   />
//                 )}
//               </div>
//               <span style={{ color: "red" }}>{errors?.package?.message}</span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Minimum Distance</Label>
//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("minPkgDistance", {
//                   required: {
//                     value: true,
//                     message: "Minimum Distance is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "minPkgDistance",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>
//                 {errors?.minPkgDistance?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Maximum Distance</Label>
//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("maxPkgDistance", {
//                   required: {
//                     value: true,
//                     message: "Maximum Distance is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "maxPkgDistance",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>
//                 {errors?.maxPkgDistance?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Total Distance</Label>
//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("pkgDistance", {
//                   required: {
//                     value: true,
//                     message: "Total Distance is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "pkgDistance",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>
//                 {errors?.pkgDistance?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Package Fee</Label>
//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("pkgCharge", {
//                   required: {
//                     value: true,
//                     message: "Package Fee is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "pkgCharge",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                     // setValue("packageValue", e.target.value.replace(/[^0-9.]/g, ''))
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>{errors?.pkgCharge?.message}</span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Per Km Charge</Label>
//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("addnlPerKmCharge", {
//                   required: {
//                     value: true,
//                     message: "Per Km Charge is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "addnlPerKmCharge",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>
//                 {errors?.addnlPerKmCharge?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           <FormGroup
//             className="col-lg-4"
//             style={{ display: "flex", alignItems: "center" }}
//           >
//             <div
//               style={{ display: "flex", alignItems: "center" }}
//               className={
//                 mix_background_layout == "dark-only"
//                   ? "checkbox-dark p-0"
//                   : "checkbox p-0"
//               }
//             >
//               <Input
//                 id="IsTaxInclusive"
//                 type="checkbox"
//                 checked={isTaxInclusiveField.value}
//                 onChange={(value) => isTaxInclusiveField.onChange(value)}
//               />
//               <Label className="mb-0" for="IsTaxInclusive">
//                 Including Tax
//               </Label>
//             </div>
//           </FormGroup>

//           <FormGroup
//             className="col-lg-4"
//             style={{ display: "flex", alignItems: "center" }}
//           >
//             <div
//               className={
//                 mix_background_layout == "dark-only"
//                   ? "checkbox-dark p-0"
//                   : "checkbox p-0"
//               }
//               style={{ display: "flex", alignItems: "center" }}
//             >
//               <Input
//                 id="IsTimeBased"
//                 type="checkbox"
//                 checked={isTimeBasedField.value}
//                 onChange={(value) => isTimeBasedField.onChange(value)}
//               />
//               <Label className="mb-0" for="IsTimeBased">
//                 Time Based
//               </Label>
//             </div>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Package Hours</Label>
//             <Col lg="12">
//               {/* <input
//             className="form-control"
//             type="number"
//             step={"any"}
//             {...register("pkgTimeInMin", {})}
//         /> */}
//               <InputGroup
//                 className="date"
//                 id="dt-minimum"
//                 data-target-input="nearest"
//               >
//                 <DatePicker
//                   className="form-control datetimepicker-input digits"
//                   selected={pkgTimeInMinField.value}
//                   onChange={handlePkgTimeInMinDate}
//                   showTimeSelect
//                   showTimeSelectOnly
//                   timeIntervals={60}
//                   timeCaption="Time"
//                   dateFormat="H:mm"
//                   timeFormat="H:mm"
//                   onKeyDown={(e) => {
//                     e.preventDefault();
//                   }}
//                 />
//               </InputGroup>
//               <span style={{ color: "red" }}>
//                 {errors?.pkgTimeInMin?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">
//               Extra Time Charge
//             </Label>
//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("addnlTimeCharge", {
//                   required: {
//                     value: true,
//                     message: "Extra Time Charge is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "addnlTimeCharge",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>
//                 {errors?.addnlTimeCharge?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">
//               Extra Time Block (in hours)
//             </Label>
//             <Col lg="12">
//               <DatePicker
//                 className="form-control datetimepicker-input digits"
//                 selected={addnlTimeChargeBlockInMinField.value}
//                 onChange={handleAddnlTimeChargeBlockInMin}
//                 showTimeSelect
//                 showTimeSelectOnly
//                 timeIntervals={60}
//                 timeCaption="Time"
//                 dateFormat="H:mm"
//                 timeFormat="H:mm"
//                 onKeyDown={(e) => {
//                   e.preventDefault();
//                 }}
//               />

//               {/* <input
//                   className="form-control"
//                   type="text"
//                   maxLength={3}
//                   {...register("addnlTimeChargeBlockInMin", {
//                     required: {
//                       value: true,
//                       message: "Extra Time Blocks (in Mins) is required",
//                     },
//                     pattern: {
//                       value: /^[0-9]{1,3}$/,
//                       message:
//                         "Please enter a valid number (up to 3 digits only)",
//                     },
//                     onChange: (e) => {
//                       const onlyNums = e.target.value.replace(/[^0-9]/g, ""); // remove non-digits
//                       setValue("addnlTimeChargeBlockInMin", onlyNums);
//                     },
//                   })}
//                 /> */}
//               {/* <input
//             className="form-control"
//             type="number"
//             step={"any"}
//             {...register("addnlTimeChargeBlockInMin", {})}
//         /> */}
//               <span style={{ color: "red" }}>
//                 {errors?.addnlTimeChargeBlockInMin?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           {isTimeBasedField.value ? (
//             <>
//               <FormGroup className="col-lg-4">
//                 <Label className="col-lg-12 col-form-label">
//                   Applicable From (Hours)
//                 </Label>
//                 <Col lg="12">
//                   <InputGroup
//                     className="date"
//                     id="dt-minimum"
//                     data-target-input="nearest"
//                   >
//                     <DatePicker
//                       className="form-control datetimepicker-input digits"
//                       selected={timeFromField.value}
//                       onChange={handleTimeFrom}
//                       showTimeSelect
//                       showTimeSelectOnly
//                       timeIntervals={60}
//                       timeCaption="Time"
//                       dateFormat="H:mm"
//                       timeFormat="H:mm"
//                       onKeyDown={(e) => {
//                         e.preventDefault();
//                       }}
//                     />
//                   </InputGroup>
//                   <span style={{ color: "red" }}>
//                     {errors?.timeFrom?.message}
//                   </span>
//                 </Col>
//               </FormGroup>

//               <FormGroup className="col-lg-4">
//                 <Label className="col-lg-12 col-form-label">
//                   Applicable To (Hours)
//                 </Label>
//                 <Col lg="12">
//                   <InputGroup
//                     className="date"
//                     id="dt-minimum"
//                     data-target-input="nearest"
//                   >
//                     <DatePicker
//                       className="form-control datetimepicker-input digits"
//                       selected={timeToField.value}
//                       onChange={handleTimeTo}
//                       showTimeSelect
//                       showTimeSelectOnly
//                       timeIntervals={60}
//                       timeCaption="Time"
//                       dateFormat="H:mm"
//                       timeFormat="H:mm"
//                       onKeyDown={(e) => {
//                         e.preventDefault();
//                       }}
//                     />
//                   </InputGroup>
//                   <span style={{ color: "red" }}>
//                     {errors?.timeTo?.message}
//                   </span>
//                 </Col>
//               </FormGroup>
//             </>
//           ) : null}
//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">Package Amount</Label>

//             <Col lg="12">
//               <input
//                 className="form-control"
//                 type="text"
//                 pattern="[0-9.]+"
//                 {...register("packageValue", {
//                   required: {
//                     value: true,
//                     message: "Package Value is required",
//                   },
//                   onChange: (e) => {
//                     setValue(
//                       "packageValue",
//                       e.target.value.replace(/[^0-9.]/g, "")
//                     );
//                   },
//                 })}
//               />
//               <span style={{ color: "red" }}>
//                 {errors?.packageValue?.message}
//               </span>
//             </Col>
//           </FormGroup>

//           {/* <FormGroup className="col-lg-12">
//     <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
//         <Input
//             id="IsNightfareTimeSlot"
//             type="checkbox"
//             checked={isNightfareTimeSlotField.value}
//             onChange={(value) => isNightfareTimeSlotField.onChange(value)}
//         />
//         <Label className="mb-0" for="IsNightfareTimeSlot" >Night Fare</Label>
//     </div>
// </FormGroup> */}
//           <FormGroup className="col-lg-4">
//             <Label className="col-lg-12 col-form-label">
//               Package Ride Type
//             </Label>
//             <Col lg="12">
//               <div className="city-select">
//                 <CustomSelect
//                   className="service-select"
//                   classNamePrefix="select"
//                   isClearable={false}
//                   isSearchable={false}
//                   value={
//                     packageRideTypeField?.value
//                       ? rideTypeDatas.find((element) => {
//                           return element?.value === packageRideTypeField?.value;
//                         })
//                       : ""
//                   }
//                   // defaultValue={cityData.find((element) => {
//                   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
//                   //   return element?.value?.id === cityField?.value?.id;
//                   // })}
//                   onChange={handlePackageRideTypeSelectChange}
//                   placeholder="Select Package Ride Type"
//                   options={rideTypeDatas}
//                 />
//               </div>
//               <span style={{ color: "red" }}>
//                 {errors?.packageRideType?.message}
//               </span>
//             </Col>
//           </FormGroup>
//         </Row>
//         {/* <Row>
//     <div style={{ color: "#2F3293", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
// </Row> */}
//         {/* {isAdvanced ? <Row>

// </Row> : null} */}

//         <div style={{ display: "flex", justifyContent: "center" }}>
//           <button
//             type="submit"
//             className="btn submit-button"
//             disabled={isSubmitting}
//           >
//             {packageRateObj?.id ? "Update" : "Create"}
//           </button>
//         </div>
//       </Form>
//       {/* ) : null} */}
//       {/* {exist ? (
//         <PackageRatesTable packId={createdPackage ? createdPackage.id : null} />
//       ) : null} */}
//     </div>
//   );
// }

// export default PackagesRatesForms;

import React, { useState, useEffect, useContext } from "react";
import {
  Label,
  Form,
  FormGroup,
  Row,
  Col,
  Input,
  InputGroup,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { showAlert } from "../../Services/Shared.service";
import {
  createPackage,
  createPackageRate,
  getPackageRate,
} from "../../Services/Packages.service";
import { useRateConstraints, validatePerKmCharge } from "../../hooks/useRateConstraints";
import moment from "moment";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { getPackagesList } from "../../Services/Packages.service";
import SharedDataContext from "../../_helper/SharedData";
import PackageRatesTable from "./PackageRatesTable";
import { Button } from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { useTariffSearch } from "../../_helper/TariffSearchContext/TariffSeachContext";

function PackagesRatesForms({ createdPackage, setTitle, handleCloseModal}) {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm({
    defaultValues: {
      package: "",
      minPkgDistance: "",
      pkgDistance: "",
      pkgTimeInMin: "",
      pkgCharge: "",
      addnlPerKmCharge: "",
      addnlTimeCharge: "",
      addnlTimeChargeBlockInMin: "",
      isTaxInclusive: false,
      timeFrom: "",
      timeTo: "",
      isTimeBased: false,
      maxPkgDistance: "",
      packageValue: "",
      isNightfareTimeSlot: false,
      // packageRideType: "",
    },
  });
  useEffect(() => {
    console.log("created PackageName", createdPackage?.name);
    setDefaultOpt(createdPackage?.name);
    setValue("package", JSON.stringify(createdPackage ? createdPackage : ""));
    setPackageName(createdPackage.name);
  }, [createdPackage]);

  console.log("createdPackage.name", createdPackage.name);

  useEffect(() => {
    console.log("created package", createdPackage);
    if (createdPackage?.id) {
      packageField.onChange(createdPackage);
    }
  }, [createdPackage]);

  const values = getValues();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { mix_background_layout } = useContext(CustomizerContext);
  const {setCloseInputModal,setPackageRateInputModal,setPackageRateCreated} = useTariffSearch();
  const [packageRateObj, setPackageRateObj] = useState({});
  const [packagesData, setPackagesData] = useState([]);
  const [defaultOpt, setDefaultOpt] = useState({ "": "" });
  const [packagePresent, setPackagePresent] = useState(false);
  const { setTabValue } = useContext(SharedDataContext);
  const [form, setForm] = useState(false);
  const [search, setSearch] = useState(true);
  const [exist, setExist] = useState(false);
  const [packageName, setPackageName] = useState("");
  const rewardConstraints = useRateConstraints();

  
  // Dynamic form states
  const [rateEntries, setRateEntries] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const MAX_ENTRIES = 6; // Maximum number of entries allowed at one stretch
  const getMinutes = (date) => {
    if (!date) return null;
    return date.getHours() * 60 + date.getMinutes();
  };
  const isTaxInclusiveField = useController({
    name: "isTaxInclusive",
    control,
  }).field;

  const isTimeBasedField = useController({
    name: "isTimeBased",
    control,
  }).field;

  const isNightfareTimeSlotField = useController({
    name: "isNightfareTimeSlot",
    control,
  }).field;

  // const packageField = useController({
  //     name: "package",
  //     control,
  //     rules: {
  //         required: {
  //             value: true,
  //             message: "Package is Required",
  //         },
  //     },
  // }).field;

  // const handlePackageField = (data) => {
  //     packageField.onChange(data.value)
  // }

  // const packageRideTypeField = useController({
  //   name: "packageRideType",
  //   control,
  //   rules: {
  //     required: {
  //       value: true,
  //       message: "Package Ride Type is Required",
  //     },
  //   },
  // }).field;

  // const handlePackageRideTypeSelectChange = (data) => {
  //   packageRideTypeField.onChange(data.value);
  // };

  // const addnlTimeChargeBlockInMinField = useController({
  //   name: "addnlTimeChargeBlockInMin",
  //   control,
  //   rules: {
  //     required: {
  //       value: true,
  //       message: "Extra Time Block (in hours) is Required",
  //     },
  //   },
  // }).field;

  // const handleAddnlTimeChargeBlockInMin = (data) => {
  //   addnlTimeChargeBlockInMinField.onChange(data);
  // };

  // const pkgTimeInMinField = useController({
  //   name: "pkgTimeInMin",
  //   control,
  //   rules: {
  //     required: {
  //       value: true,
  //       message: "Package Hours is Required",
  //     },
  //   },
  // }).field;

  // const handlePkgTimeInMinDate = (data) => {
  //   pkgTimeInMinField.onChange(data);
  // };

  const timeFromField = useController({
    name: "timeFrom",
    control,
    rules: {
      required: {
        value: isTimeBasedField.value ? true : false,
        message: "Time From is Required",
      },
    },
  }).field;

  const handleTimeFrom = (data) => {
    timeFromField.onChange(data);
  };

  // const timeToField = useController({
  //   name: "timeTo",
  //   control,
  //   rules: {
  //     required: {
  //       value: isTimeBasedField.value ? true : false,
  //       message: "Applicable To is Required",
  //     },
  //   },
  // }).field;
  const timeToField = useController({
        name: "timeTo",
        control,
        rules: {
          required: {
            value: isTimeBasedField.value ? true : false,
            message: "Time To is Required",
          },
          validate: (value) => {
            if (!value || !timeFromField.value) return true; // skip if no data yet
  
            const from = new Date(timeFromField.value).getHours();
            const to = new Date(value).getHours();
  
            // Allow ONLY 12 AM → 12 AM
            if (from === 0 && to === 0) return true;
  
            // Reject same time (except 12→12)
            if (from === to) return "Start time and end time cannot be the same";
  
            // Reject lesser time
            if (to != 0 && to < from) return "Time To should be greater than Time From";
  
            return true;
          },
        },
      }).field;


  const handleTimeTo = (data) => {
    timeToField.onChange(data);
  };

  const rideTypeDatas = [
    { label: "All", value: "All" },
    { label: "AirportToCity", value: "AirportToCity" },
    { label: "CityToAirport", value: "CityToAirport" },
    { label: "CityToCity", value: "CityToCity" },
  ];

  useEffect(() => {
    const fetchTableData = () => {
      const serviceCityId = null;
      let obj = {
        isPagination: false,
        serviceCityId: serviceCityId,
        page: 0,
        size: 30,
      };
      getPackagesList(obj).then((result) => {
        let packageOptions = result.data.list.map((d) => {
          return {
            label: d.name,
            value: d,
          };
        });
        setPackagesData(packageOptions);
      });
    };
    fetchTableData();
  }, []);

  // useEffect(() => {
  //     console.log("created package",createdPackage);
  //     if (createdPackage?.id) {
  //         packageField.onChange(createdPackage.name)
  //     }
  // }, [packageField])

  const packageField = useController({
    name: "package",
    control,
    rules: {
      required: {
        value: true,
        message: "Package is Required",
      },
    },
  }).field;

  useEffect(() => {
    if (createdPackage.id) {
      packageField.onChange({
        id: createdPackage.id,
        name: createdPackage.name,
      });
      // console.log("createdd package inside useEffect",createdPackage.name)
    }
  }, [createdPackage]);
  const handleTime_To = (time, constraint) => {
  if (!time) return 0;

  const hours = time.getHours();     
  const minutes = time.getMinutes(); 
  const seconds = time.getSeconds();

  let totalSeconds = hours * 3600 + minutes * 60 + seconds;
  let totalMinutes = hours * 60 + minutes;

  // Special case: 12 AM → 12 AM means full day
  if (totalSeconds === 0 && constraint === "S") {
    return 86400;
  }
  if (totalMinutes === 0 && constraint === "M") {
    return 1440;
  }

  return constraint === "S" ? totalSeconds : totalMinutes;
};


const convertTimeToSeconds = (time) => {
  const hr = Number(moment(time).format("HH"));
  const min = Number(moment(time).format("mm"));
  const sec = Number(moment(time).format("ss"));

  return hr * 3600 + min * 60 + sec;
};

const normalizeTimeTo = (time) => {
  let seconds = convertTimeToSeconds(time);

  // 12 AM special case
  if (seconds === 0) return 86400;

  return seconds;
};
  
const normalizeTimeFrom = (time) => {
  return convertTimeToSeconds(time); // 12 AM stays 0
};

  // Add or update rate entry in the list
  const onFormSubmit = (formValues) => {
    console.log("form values", formValues);
    
    const rateEntry = {
      packagesId: Number(formValues.package.id),
      packageName: formValues.package.name,
      minPkgDistance: formValues.minPkgDistance
        ? Number(formValues.minPkgDistance)
        : 0,
      pkgDistance: formValues.pkgDistance ? Number(formValues.pkgDistance) : 0,
      pkgTimeInMin: formValues.pkgTimeInMin
        ? handleTime_To(formValues.pkgTimeInMin, "M")
        : 0,
      pkgTimeInMinDisplay: formValues.pkgTimeInMin 
        ? moment(formValues.pkgTimeInMin).format("H:mm")
        : "",
      pkgCharge: formValues.pkgCharge ? Number(formValues.pkgCharge) : 0,
      addnlPerKmCharge: formValues.addnlPerKmCharge
        ? Number(formValues.addnlPerKmCharge)
        : 0,
      addnlTimeCharge: formValues.addnlTimeCharge
        ? Number(formValues.addnlTimeCharge)
        : 0,
      addnlTimeChargeBlockInMin: formValues.addnlTimeChargeBlockInMin
        ? Number(
            moment
              .duration(
                moment(formValues.addnlTimeChargeBlockInMin).format("HH:mm:ss")
              )
              .asMinutes()
          )
        : 0,
      addnlTimeChargeBlockInMinDisplay: formValues.addnlTimeChargeBlockInMin
        ? moment(formValues.addnlTimeChargeBlockInMin).format("H:mm")
        : "",
      isTaxInclusive: formValues.isTaxInclusive ? true : false,
      timeFrom: formValues.timeFrom
        ? convertTimeToSeconds(formValues.timeFrom)
        : 0,
      timeFromDisplay: formValues.timeFrom 
        ? moment(formValues.timeFrom).format("h:mm A")
        : "",
      timeTo: formValues.timeTo ? handleTime_To(formValues.timeTo, "S") : 86400,
      timeToDisplay: formValues.timeTo 
        ? moment(formValues.timeTo).format("h:mm A")
        : "",
      isTimeBased: formValues.isTimeBased ? true : false,
      maxPkgDistance: formValues.maxPkgDistance
        ? Number(formValues.maxPkgDistance)
        : 0,
      packageValue: formValues.packageValue
        ? Number(formValues.packageValue)
        : 0,
      isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
      // packageRideType: formValues.packageRideType,
    };

    // Validate time overlap if time-based is enabled
    if (formValues.isTimeBased && formValues.timeFrom && formValues.timeTo) {

      const newTimeFrom = normalizeTimeFrom(formValues.timeFrom);
      const newTimeTo = normalizeTimeTo(formValues.timeTo);

      // Rule 1 — Same Time disallowed except "12 AM → 12 AM"
      if (newTimeFrom === newTimeTo) {
        if (!(newTimeFrom === 0 && newTimeTo === 86400)) {
          showAlert("error", "Start time and End time cannot be the same");
          return;
        }
      }

      // Rule 2 — End must be > Start (except full day)
      if (newTimeTo <= newTimeFrom && !(newTimeFrom === 0 && newTimeTo === 86400)) {
        showAlert("error", "End time must be greater than start time");
        return;
      }

      // Rule 3 — Overlap detection
      for (let i = 0; i < rateEntries.length; i++) {
        if (editingIndex !== null && i === editingIndex) continue;

        const { timeFrom: ef, timeTo: et, isTimeBased } = rateEntries[i];
        if (!isTimeBased) continue;

        const nf = newTimeFrom;
        const nt = newTimeTo;

        const hasOverlap =
          (nf >= ef && nf < et) ||
          (nt > ef && nt <= et) ||
          (nf <= ef && nt >= et);

        if (hasOverlap) {
          showAlert(
            "error",
            `Time range overlaps with existing package rate (${rateEntries[i].timeFromDisplay} to ${rateEntries[i].timeToDisplay}).`
          );
          return;
        }
      }
    }


    if (editingIndex !== null) {
      // Update existing entry
      const updatedEntries = [...rateEntries];
      updatedEntries[editingIndex] = rateEntry;
      setRateEntries(updatedEntries);
      setEditingIndex(null);
      showAlert("success", "Rate entry updated successfully");
    } else {
      // Check if maximum entries limit is reached
      if (rateEntries.length >= MAX_ENTRIES) {
        showAlert("error", `You can only create up to ${MAX_ENTRIES} entries at one time. Please submit the current entries before adding more.`);
        return;
      }
      // Add new entry
      setRateEntries([...rateEntries, rateEntry]);
      showAlert("success", "Rate entry added successfully");
    }

    // Reset form
    reset({
      package: createdPackage ? JSON.stringify(createdPackage) : "",
      minPkgDistance: "",
      pkgDistance: "",
      pkgTimeInMin: "",
      pkgCharge: "",
      addnlPerKmCharge: "",
      addnlTimeCharge: "",
      addnlTimeChargeBlockInMin: "",
      isTaxInclusive: false,
      timeFrom: "",
      timeTo: "",
      isTimeBased: false,
      maxPkgDistance: "",
      packageValue: "",
      isNightfareTimeSlot: false,
      // packageRideType: "",
    });

    // Re-set package field if createdPackage exists
    if (createdPackage?.id) {
      packageField.onChange({
        id: createdPackage.id,
        name: createdPackage.name,
      });
    }
  };

  // Submit all rate entries to the API
  const submitAllRates = async () => {
    if (rateEntries.length === 0) {
      showAlert("error", "Please add at least one rate entry");
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Submit all rates sequentially
      const body = rateEntries.map((entry) => ({
          packagesId: entry.packagesId,
          minPkgDistance: entry.minPkgDistance,
          pkgDistance: entry.pkgDistance,
          pkgTimeInMin: entry.pkgTimeInMin,
          pkgCharge: entry.pkgCharge,
          addnlPerKmCharge: entry.addnlPerKmCharge,
          addnlTimeCharge: entry.addnlTimeCharge,
          addnlTimeChargeBlockInMin: entry.addnlTimeChargeBlockInMin,
          isTaxInclusive: entry.isTaxInclusive,
          timeFrom: entry.timeFrom,
          timeTo: entry.timeTo,
          isTimeBased: entry.isTimeBased,
          maxPkgDistance: entry.maxPkgDistance,
          packageValue: entry.packageValue,
          isNightfareTimeSlot: entry.isNightfareTimeSlot,
          // packageRideType: entry.packageRideType,
        }));
        
        await createPackageRate({ rates: body });
      
      
      showAlert("success", `${rateEntries.length} Package Rate(s) Created Successfully`);
      setCloseInputModal(false);
      setRateEntries([]);
      setIsSubmitting(false);
      setPackageRateInputModal(false);
      setPackageRateCreated(true); 
      setTabValue(0);
      
      // Close modal if handleCloseModal is provided (for corporate client flow)
      if (handleCloseModal) {
        handleCloseModal();
      }
    } catch (err) {
      showAlert(
        "error",
        err.response?.data?.message
          ? err.response.data.message
          : "Something went wrong"
      );
      setIsSubmitting(false);
    }
  };

  // Edit a rate entry
  const handleEditEntry = (index) => {
    const entry = rateEntries[index];
    setEditingIndex(index);
    
    // Helper function to convert time display back to Date
  const parseTimeDisplay = (timeDisplay, is24Hour = false) => {
    if (!timeDisplay) return "";
    
    if (is24Hour) {
      // For 24-hour format like "11:30"
      const [hours, minutes] = timeDisplay.split(':');
      const date = new Date();
      date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
      return date;
    } else {
      // For 12-hour format like "11:30 PM"
      return moment(timeDisplay, "h:mm A").toDate();
    }
  };
    // Populate form with entry data
    setValue("package", { id: entry.packagesId, name: entry.packageName });
    setValue("minPkgDistance", entry.minPkgDistance);
    setValue("pkgDistance", entry.pkgDistance);
    setValue("pkgTimeInMin", entry.pkgTimeInMin ? new Date(`1970-01-01T${entry.pkgTimeInMinDisplay}:00`) : "");
    setValue("pkgCharge", entry.pkgCharge);
    setValue("addnlPerKmCharge", entry.addnlPerKmCharge);
    setValue("addnlTimeCharge", entry.addnlTimeCharge);
    setValue("addnlTimeChargeBlockInMin", entry.addnlTimeChargeBlockInMin ? parseTimeDisplay(entry.addnlTimeChargeBlockInMinDisplay, true) : "");
    setValue("isTaxInclusive", entry.isTaxInclusive);
    setValue("timeFrom", entry.timeFromDisplay ? parseTimeDisplay(entry.timeFromDisplay, false) : "");
  setValue("timeTo", entry.timeToDisplay ? parseTimeDisplay(entry.timeToDisplay, false) : "");
    setValue("isTimeBased", entry.isTimeBased);
    setValue("maxPkgDistance", entry.maxPkgDistance);
    setValue("packageValue", entry.packageValue);
    setValue("isNightfareTimeSlot", entry.isNightfareTimeSlot);
    // setValue("packageRideType", entry.packageRideType);

    // Scroll to form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Remove a rate entry
  const handleRemoveEntry = (index) => {
    const updatedEntries = rateEntries.filter((_, i) => i !== index);
    setRateEntries(updatedEntries);
    showAlert("success", "Rate entry removed");
    
    // If editing this entry, cancel edit mode
    if (editingIndex === index) {
      setEditingIndex(null);
      reset();
    }
  };

  // Cancel editing
  const handleCancelEdit = () => {
    setEditingIndex(null);
    reset({
      package: createdPackage ? JSON.stringify(createdPackage) : "",
      minPkgDistance: "",
      pkgDistance: "",
      pkgTimeInMin: "",
      pkgCharge: "",
      addnlPerKmCharge: "",
      addnlTimeCharge: "",
      addnlTimeChargeBlockInMin: "",
      isTaxInclusive: false,
      timeFrom: "",
      timeTo: "",
      isTimeBased: false,
      maxPkgDistance: "",
      packageValue: "",
      isNightfareTimeSlot: false,
      // packageRideType: "",
    });
    
    if (createdPackage?.id) {
      packageField.onChange({
        id: createdPackage.id,
        name: createdPackage.name,
      });
    }
  };

  // useEffect(()=>{
  //     if(selectedPackage.id){
  //         packageField.onChange({ id: selectedPackage.id, name: selectedPackage.name })
  //     }
  // },[selectedPackage])

  return (
    <div>
      <Form onSubmit={handleSubmit(onFormSubmit)}>
        <Row>
          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Package</Label>
            <Col lg="12">
              <div className="city-select">
                {createdPackage ? (
                  <input
                    className="form-control"
                    type="text"
                    disabled={true}
                    // value={`${createdPackage.name}`}
                    value={packageField.value.name}
                    // {...register("package",{
                    //     required: {
                    //         value: true,
                    //         message: "Package is required",
                    //     },
                    // })}
                  />
                ) : (
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    //  isDisabled={editId ? true : false}
                    value={
                      packageField?.value?.id
                        ? packagesData.find((element) => {
                            return (
                              element?.value?.id === packageField?.value?.id
                            );
                          })
                        : ""
                    }
                    //   // defaultValue={cityData.find((element) => {
                    //   //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                    //   //   return element?.value?.id === cityField?.value?.id;
                    //   // })}

                    //  onChange={}
                    placeholder="Select Package"
                    options={packagesData}
                  />
                )}
              </div>
              <span style={{ color: "red" }}>{errors?.package?.message}</span>
            </Col>
          </FormGroup>

          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Minimum Distance</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("minPkgDistance", {
                  required: {
                    value: true,
                    message: "Minimum Distance is required",
                  },
                  onChange: (e) => {
                    setValue(
                      "minPkgDistance",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.minPkgDistance?.message}
              </span>
            </Col>
          </FormGroup>

          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Maximum Distance</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("maxPkgDistance", {
                  required: {
                    value: true,
                    message: "Maximum Distance is required",
                  },
                  validate: (value) => {
                  const min = parseFloat(getValues("minPkgDistance"));
                  const max = parseFloat(value);

                  // If minimum not entered yet, allow
                  if (!min || !max) return true;

                  if (max <= min) {
                    return "Maximum Distance must be greater than Minimum Distance";
                  }

                  return true;
                },

                  onChange: (e) => {
                    setValue(
                      "maxPkgDistance",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                    setValue(
                      "pkgDistance",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.maxPkgDistance?.message}
              </span>
            </Col>
          </FormGroup>

          {/* <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Total Distance</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("pkgDistance", {
                  required: {
                    value: true,
                    message: "Total Distance is required",
                  },
                  onChange: (e) => {
                    setValue(
                      "pkgDistance",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.pkgDistance?.message}
              </span>
            </Col>
          </FormGroup> */}

          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Package Fee</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("pkgCharge", {
                  required: {
                    value: true,
                    message: "Package Fee is required",
                  },
                  onChange: (e) => {
                    setValue(
                      "pkgCharge",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                    setValue("packageValue", e.target.value.replace(/[^0-9.]/g, ''))
                  },
                })}
              />
              <span style={{ color: "red" }}>{errors?.pkgCharge?.message}</span>
            </Col>
          </FormGroup>

          <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Per Km Charge</Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("addnlPerKmCharge", {
                  required: {
                    value: true,
                    message: "Per Km Charge is required",
                  },
                  validate: (value) => validatePerKmCharge(value, rewardConstraints),
                  onChange: (e) => {
                    setValue(
                      "addnlPerKmCharge",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.addnlPerKmCharge?.message}
              </span>
            </Col>
          </FormGroup>

          {/* <FormGroup
            className="col-lg-4"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              style={{ display: "flex", alignItems: "center" }}
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
            >
              <Input
                id="IsTaxInclusive"
                type="checkbox"
                checked={isTaxInclusiveField.value}
                onChange={(value) => isTaxInclusiveField.onChange(value)}
              />
              <Label className="mb-0" for="IsTaxInclusive">
                Including Tax
              </Label>
            </div>
          </FormGroup> */}

         

          {/* <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Package Hours</Label>
            <Col lg="12">
              <InputGroup
                className="date"
                id="dt-minimum"
                data-target-input="nearest"
              >
                <DatePicker
                  className="form-control datetimepicker-input digits"
                  selected={pkgTimeInMinField.value}
                  onChange={handlePkgTimeInMinDate}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={60}
                  timeCaption="Time"
                  dateFormat="H:mm"
                  timeFormat="H:mm"
                  onKeyDown={(e) => {
                    e.preventDefault();
                  }}
                />
              </InputGroup>
              <span style={{ color: "red" }}>
                {errors?.pkgTimeInMin?.message}
              </span>
            </Col>
          </FormGroup> */}

          {/* <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">
              Extra Time Charge
            </Label>
            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("addnlTimeCharge", {
                  required: {
                    value: true,
                    message: "Extra Time Charge is required",
                  },
                  onChange: (e) => {
                    setValue(
                      "addnlTimeCharge",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.addnlTimeCharge?.message}
              </span>
            </Col>
          </FormGroup> */}

          {/* <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">
              Extra Time Block (in hours)
            </Label>
            <Col lg="12">
              <DatePicker
                className="form-control datetimepicker-input digits"
                selected={addnlTimeChargeBlockInMinField.value}
                onChange={handleAddnlTimeChargeBlockInMin}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={60}
                timeCaption="Time"
                dateFormat="H:mm"
                timeFormat="H:mm"
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
              /> */}

              {/* <input
                  className="form-control"
                  type="text"
                  maxLength={3}
                  {...register("addnlTimeChargeBlockInMin", {
                    required: {
                      value: true,
                      message: "Extra Time Blocks (in Mins) is required",
                    },
                    pattern: {
                      value: /^[0-9]{1,3}$/,
                      message:
                        "Please enter a valid number (up to 3 digits only)",
                    },
                    onChange: (e) => {
                      const onlyNums = e.target.value.replace(/[^0-9]/g, ""); // remove non-digits
                      setValue("addnlTimeChargeBlockInMin", onlyNums);
                    },
                  })}
                /> */}
              {/* <input
            className="form-control"
            type="number"
            step={"any"}
            {...register("addnlTimeChargeBlockInMin", {})}
        /> */}
              {/* <span style={{ color: "red" }}>
                {errors?.addnlTimeChargeBlockInMin?.message}
              </span>
            </Col>
          </FormGroup> */}

          {isTimeBasedField.value ? (
            <>
              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">
                  Time From (Hours)
                </Label>
                <Col lg="12">
                  <InputGroup
                    className="date"
                    id="dt-minimum"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input digits"
                      selected={timeFromField.value}
                      onChange={handleTimeFrom}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={60}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      timeFormat="h:mm aa"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                  <span style={{ color: "red" }}>
                    {errors?.timeFrom?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-4">
                <Label className="col-lg-12 col-form-label">
                  Time To (Hours)
                </Label>
                <Col lg="12">
                  <InputGroup
                    className="date"
                    id="dt-minimum"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input digits"
                      selected={timeToField.value}
                      onChange={handleTimeTo}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={60}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      timeFormat="h:mm aa"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                  <span style={{ color: "red" }}>
                    {errors?.timeTo?.message}
                  </span>
                </Col>
              </FormGroup>
            </>
          ) : null}
          {/* <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">Package Amount</Label>

            <Col lg="12">
              <input
                className="form-control"
                type="text"
                pattern="[0-9.]+"
                {...register("packageValue", {
                  required: {
                    value: true,
                    message: "Package Value is required",
                  },
                  onChange: (e) => {
                    setValue(
                      "packageValue",
                      e.target.value.replace(/[^0-9.]/g, "")
                    );
                  },
                })}
              />
              <span style={{ color: "red" }}>
                {errors?.packageValue?.message}
              </span>
            </Col>
          </FormGroup> */}

          {/* <FormGroup className="col-lg-12">
    <div className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
        <Input
            id="IsNightfareTimeSlot"
            type="checkbox"
            checked={isNightfareTimeSlotField.value}
            onChange={(value) => isNightfareTimeSlotField.onChange(value)}
        />
        <Label className="mb-0" for="IsNightfareTimeSlot" >Night Fare</Label>
    </div>
</FormGroup> */}
          {/* <FormGroup className="col-lg-4">
            <Label className="col-lg-12 col-form-label">
              Package Ride Type
            </Label>
            <Col lg="12">
              <div className="city-select">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={
                    packageRideTypeField?.value
                      ? rideTypeDatas.find((element) => {
                          return element?.value === packageRideTypeField?.value;
                        })
                      : ""
                  }
                  // defaultValue={cityData.find((element) => {
                  //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                  //   return element?.value?.id === cityField?.value?.id;
                  // })}
                  onChange={handlePackageRideTypeSelectChange}
                  placeholder="Select Package Ride Type"
                  options={rideTypeDatas}
                />
              </div>
              <span style={{ color: "red" }}>
                {errors?.packageRideType?.message}
              </span>
            </Col>
          </FormGroup> */}
           <FormGroup
            className="col-lg-12"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div
              className={
                mix_background_layout == "dark-only"
                  ? "checkbox-dark p-0"
                  : "checkbox p-0"
              }
              style={{ display: "flex", alignItems: "center" }}
            >
              <Input
                id="IsTimeBased"
                type="checkbox"
                checked={isTimeBasedField.value}
                onChange={(value) => isTimeBasedField.onChange(value)}
              />
              <Label className="mb-0" for="IsTimeBased">
                Time Based
              </Label>
            </div>
          </FormGroup>
        </Row>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <button
            type="submit"
            className="btn submit-button"
            disabled={isSubmitting || (editingIndex === null && rateEntries.length >= MAX_ENTRIES)}
          >
            {editingIndex !== null ? "Update Rate" : "Add Rate"}
          </button>
          {editingIndex !== null && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancelEdit}
            >
              Cancel Edit
            </button>
          )}
        </div>
      </Form>

      {/* Show entry count and limit
      {rateEntries.length > 0 && (
        <div style={{ 
          marginTop: "15px", 
          padding: "10px", 
          backgroundColor: rateEntries.length >= MAX_ENTRIES ? "#fff3cd" : "#d1ecf1",
          borderRadius: "5px",
          textAlign: "center",
          border: `1px solid ${rateEntries.length >= MAX_ENTRIES ? "#ffc107" : "#bee5eb"}`
        }}>
          <strong>
            {rateEntries.length >= MAX_ENTRIES 
              ? `Maximum limit reached! You have ${rateEntries.length} entries. Please submit them before adding more.`
              : `You have added ${rateEntries.length} out of ${MAX_ENTRIES} allowed entries.`
            }
          </strong>
        </div>
      )} */}

      {/* Display added rate entries */}
      {rateEntries.length > 0 && (
        <div style={{ marginTop: "30px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
            <h5>Added Rate Entries ({rateEntries.length})</h5>
            <Button
              variant="contained"
              color="primary"
              onClick={submitAllRates}
              disabled={isSubmitting}
              style={{ textTransform: "none" }}
            >
              {isSubmitting ? "Submitting..." : `Submit All ${rateEntries.length} Rate(s)`}
            </Button>
          </div>
          
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Package</th>
                  <th>Min Distance</th>
                  <th>Max Distance</th>
                  {/* <th>Total Distance</th> */}
                  <th>Package Fee</th>
                  <th>Per Km Charge</th>
                  {/* <th>Package Hours</th> */}
                  {/* <th>Extra Time Charge</th>
                  <th>Extra Time Block</th> */}
                  {/* <th>Package Amount</th> */}
                  <th>Ride Type</th>
                  {/* <th>Tax Inclusive</th> */}
                  <th>Time Based</th>
                  {rateEntries.some(entry => entry.isTimeBased) && (
                    <>
                      <th>Time From</th>
                      <th>Time To</th>
                    </>
                  )}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {rateEntries.map((entry, index) => (
                  <tr key={index} style={{ backgroundColor: editingIndex === index ? "#fff3cd" : "transparent" }}>
                    <td>{index + 1}</td>
                    <td>{entry.packageName}</td>
                    <td>{entry.minPkgDistance}</td>
                    <td>{entry.maxPkgDistance}</td>
                    {/* <td>{entry.pkgDistance}</td> */}
                    <td>{entry.pkgCharge}</td>
                    <td>{entry.addnlPerKmCharge}</td>
                    {/* <td>{entry.pkgTimeInMinDisplay}</td> */}
                    {/* <td>{entry.addnlTimeCharge}</td>
                    <td>{entry.addnlTimeChargeBlockInMinDisplay}</td> */}
                    {/* <td>{entry.packageValue}</td> */}
                    {/* <td>{entry.packageRideType}</td> */}
                    {/* <td>{entry.isTaxInclusive ? "Yes" : "No"}</td> */}
                    <td>{entry.isTimeBased ? "Yes" : "No"}</td>
                    {rateEntries.some(e => e.isTimeBased) && (
                      <>
                        <td>{entry.isTimeBased ? entry.timeFromDisplay : "-"}</td>
                        <td>{entry.isTimeBased ? entry.timeToDisplay : "-"}</td>
                      </>
                    )}
                    <td>
                      <div style={{ display: "flex", gap: "5px" }}>
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() => handleEditEntry(index)}
                          disabled={isSubmitting}
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleRemoveEntry(index)}
                          disabled={isSubmitting}
                        >
                          Remove
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default PackagesRatesForms;